import React, { forwardRef, RefObject } from 'react';
import { BookModel } from '../../../../../interfaces/book.interface';
import Button from '../../../../../components/Common/Button';
import Logo from '../../../../Admin/logo.webp';

interface SummarySectionProps {
  mode: 'Grid' | 'Page';
  bookData: BookModel;
  setSummaryModal: (value: boolean) => void;
  targetRefs: RefObject<any>;
}

const SummarySection = forwardRef<HTMLDivElement, SummarySectionProps>(
  ({ mode, bookData, setSummaryModal, targetRefs }, ref) => {
    return (
      <div className="flex flex-col gap-2">
        <div
          className={`h-[350px] w-[350px]  md:w-[600px] md:h-[600px] flex flex-col rounded-lg mx-auto py-3 bg-gray-200 ${mode === 'Grid' ? '' : 'mb-4'
          } `}
          style={{
            backgroundImage: `url("/pattern.png")`,
            backgroundSize: 'cover'
          }}
        ></div>
        <div
          className="flex justify-center items-center mb-4 md:mb-0  h-[350px] w-[350px] md:w-[600px] md:h-[600px] rounded-lg mx-auto bg-white relative">
          <p className="m-4 text-gray-500 text-base   text-center">
            This page is Intentionally left blank
          </p>
        </div>
        <div
          className="flex flex-col items-center"
          id="edit-summary"
          key="edit-summary"
          ref={(ref) => (targetRefs.current['edit-summary'] = ref) as any}
        >
          <div
            className="h-[350px] w-[350px] md:w-[600px] md:h-[600px] flex flex-col justify-between mx-auto  py-4 px-5 items-center rounded font-serif"
            style={{
              backgroundImage: `url("/texture.png")`,
              backgroundSize: 'cover'
            }}
          >
            <div className="flex flex-col items-center gap-6 p-5 md:p-16 md:gap-12">
              <h3 className="text-center text-xl align-center  md:text-2xl bold font-yuji-boku">
                {bookData?.title}
              </h3>
              <h3 className="text-[10px] md:text-lg font-poppins text-black text-justify">
                {bookData?.summary?.length! > 400
                  ? bookData?.summary?.slice(0, 400) + '...'
                  : bookData?.summary}
              </h3>
            </div>
            <div className="w-full flex justify-end items-center gap-3">
              <div className="flex items-baseline gap-1">
                <img className="h-3 w-auto md:h-12" src={Logo} alt="Build My Story" />
              </div>
              <div>
                <div className="flex flex-col gap-1">
                  <h3 className="text-[8px] md:text-base">www.buildmystory.com</h3>
                </div>
              </div>
            </div>
          </div>
          <Button
            title="Edit Summary"
            onClick={() => {
              setSummaryModal(true);
            }}
            className="bg-storyblueSecondLightText flex  text-white  font-sans rounded-2xl px-4 py-2 text-xs m-4  h-8 w-[120px] justify-center"
          />
        </div>
      </div>
    );
  }
);

export default SummarySection;
